import { registry } from '@cian/mf-registry/browser';

export const apiCall = async <T, R = void>(name: string, path: string, parameters?: T): Promise<R> => {
  const api = await registry().microfrontendStrict(name).api()?.ensure();

  return api?.call(path, parameters) as Promise<R>;
};
